import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-white md:text-2xl text-xl" }




export default /*#__PURE__*/_defineComponent({
  __name: 'PrimaryLabel',
  props: {
    text: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(props.text), 1))
}
}

})